export const menuItemsList = [
  /* {
    title: "Home",
    url: "/",
  }, */
  {
    title: "Prodotti",
    permessi: ["read:database", "read:dashboard_pubblicazioni"],
    mobile: false,
    url: "/",
    submenu: [
      {
        title: "Pubblicazione",
        url: "uiPubblicazione",
        permessi: "update:database",
      },
      {
        title: "Dashboard pubbl",
        url: "dashboardPubblicazioni",
        permessi: "read:dashboard_pubblicazioni",
      },
      {
        title: "Stats pubbl brand",
        url: "statsPubblBrand",
        permessi: "read:database",
      },
      {
        title: "Priorità brand",
        url: "prioritaBrand",
        permessi: "update:assegnazioniPubblicazione",
      },
      {
        title: "Ultime modifiche",
        url: "modificheUtenti",
        permessi: "read:database",
      },
      {
        title: "Categorie web",
        url: "/",
        permessi: "update:database",
        submenu: [
          {
            title: "Map categorie",
            url: "categorieWebMap",
            permessi: "update:database",
          },
          {
            title: "Cat Prestashop",
            url: "categorieWebPS",
            permessi: "update:database",
          },
          {
            title: "Valori da mappare",
            url: "valoriDaMappare",
            permessi: "update:database",
          },
          {
            title: "Conflitti default",
            url: "conflittiDefaultCategorie",
            permessi: "update:database",
          },
        ],
      },
      {
        title: "Traduzioni",
        url: "traduzioni",
        permessi: "read:database",
        submenu: [
          {
            title: "Massive",
            url: "traduzioni",
            permessi: "read:database",
          },
          {
            title: "Glossario",
            url: "glossarioTraduzioni",
            permessi: "read:database",
          },
        ],
      },
      {
        title: "Allineamento",
        url: "avanzamentoBackfill",
        permessi: ["read:database", "read:debug", "read:dashboard_pubblicazioni"],
        submenu: [
          {
            title: "On demand",
            url: "allineamentoPrestashop",
            permessi: "read:debug",
          },
          {
            title: "Backfill",
            url: "avanzamentoBackfill",
            permessi: ["read:database", "read:dashboard_pubblicazioni"],
          },
          {
            title: "Stato articoli",
            url: "statoArticoli",
            permessi: "read:database",
          },
          {
            title: "Sandbox articolo",
            url: "avanzamentoBackfill/sandbox",
            permessi: ["read:database", "read:dashboard_pubblicazioni"],
          },
        ],
      },
      {
        title: "Fusione Bottero",
        url: "matchBottero",
        permessi: "update:database",
        submenu: [
          {
            title: "Match Bottero",
            url: "matchBottero",
            permessi: "write:debug",
          },
          {
            title: "Art. BS matchati",
            url: "vediMatchBsVs",
            permessi: "read:database",
          },
          {
            title: "Art. VS matchati",
            url: "vediMatchVsBs",
            permessi: "read:database",
          },
          {
            title: "Stats match",
            url: "statsMatchBottero",
            permessi: "read:database",
          },
        ],
      },
      {
        title: "Importa CSV",
        url: "caricacsv",
        permessi: "update:importcsv",
      },
      {
        title: "Altro",
        url: "pubbweek",
        permessi: "update:database",
        submenu: [
          {
            title: "Snapshot pubb settimana",
            url: "pubbweek",
            permessi: "update:database",
          },
        ],
      },
    ],
  },
  {
    title: "Logistica",
    url: "dbOrdini",
    permessi: "read:logistica",
    mobile: true,
    submenu: [
      {
        title: "Database ordini",
        url: "dbOrdini",
        permessi: "read:logistica",
        mobile: true,
      },
      {
        title: "Stampa ordini",
        url: "stampaOrdini",
        permessi: "print:logistica",
        mobile: true,
      },
      {
        title: "Dashboard ordini",
        url: "dashboardOrdini",
        permessi: "read:logistica",
        mobile: true,
      },
    ],
  },
  {
    title: "Magazzino",
    url: "logisticaBeta",
    permessi: "read:logistica",
    mobile: true,
    submenu: [
      {title:"Controllo magazzino",url:"controlloMagazzino",permessi:["print:logistica","update:logistica"],mobile:true},
      {
        title: "Inventario",
        url: "mag_inventario",
        permessi: "update:inventario",
      },
      /* {
        title: "Spara ordini",
        url: "logisticaBeta",
        mobile: true,
        permessi: "update:logistica",
      },
      {
        title: "Spara trovati",
        url: "sparaTrovati",
        mobile: true,
        permessi: "update:logistica",
      },
      {
        title: "Spara ordini Offline",
        url: "logisticaOffline",
        mobile: true,
        permessi: "update:logistica",
      }, */
      {
        title: "Check ordini",
        url: "checkSparati",
        permessi: "read:logistica",
        mobile: true,
      },
    ],
  },
  {
    title: "Contabilità",
    url: "/",
    permessi: "read:contabile",
    mobile: false,
    submenu: [
      {
        title: "Pagamenti",
        url: "pagamenti",
      },
      {
        title: "Rimborsi",
        url: "rimborsi",
      },
      {
        title: "Corrispettivi mese",
        url: "corrispettiviMese",
      },
      {
        title: "Controlli TT",
        url: "/",
        submenu: [
          {
            title: "Controlli Tradetracker",
            url: "controlliTradetracker",
          },
        ],
      },
      {
        title: "Controlli corr.",
        url: "/",
        submenu: [
          {
            title: "Controlli corrispettivi",
            url: "controlliCorrispettivi",
          },
          {
            title: "Transazioni Domino",
            url: "transazioniDominoCorrispettivi",
          },
          {
            title: "Riepilogo confermati",
            url: "riepilogoCorrispettiviConfermati",
          },
          {
            title: "Controllo Amazon IVA",
            url: "controlloCorrispettiviAmazon",
          },
          {
            title: "Controllo Prestashop",
            url: "controlloCorrispettiviPrestashop",
          },
          {
            title: "Controllo gestionale",
            url: "controlloCorrispettiviGestionale",
          },
        ],
      },
    ],
  },
  {
    title: "Manutenzione",
    url: "/",
    permessi: "update:database",
    mobile: false,
    submenu: [
      {
        title: "Valori default logistica",
        url: "configurazione-logistica",
        permessi: ["read:logistica", "read:database"],
      },
      {
        title: "Status",
        url: "status",
        permessi: "read:logistica",
      },
      {
        title: "Dashboard",
        url: "AreaDashboard",
        permessi: "update:prestashop",
      },
      {
        title: "Dashb. imm.",
        url: "dashboardImmagini",
        permessi: "update:prestashop",
      },
      {
        title: "Dashb. R2 imm",
        url: "dashboardR2Immagini",
        permessi: "update:prestashop",
      },
      {
            title: "Dashb. jobs",
            url: "jobMassiviPubblicazione",
      },
      {
        title: "PS Tools",
        url: "/",
        permessi: "read:debug",
        submenu: [
          {
            title: "Genera html menu",
            url: "psTools",
            permessi: "write:debug",
          },
          {
            title: "HTML per campagne",
            url: "htmlCamp",
          },
          {
            title: "Modifiche massive",
            url: "modificaMassivaDatoUlteriore",
            permessi: "write:debug",
          },
          {
            title: "Rimozione categorie",
            url: "rimozioneMassivaCategorieDB",
            permessi: "write:debug",
          },
          {
            title: "Aggiunta categorie",
            url: "aggiuntaMassivaCategorieDB",
            permessi: "write:debug",
          },
        ],
      },
      {
        title: "DB Tools",
        url: "/",
        permessi: "read:debug",
        submenu: [
          {
            title: "Rinomina brand",
            url: "dbTools",
            permessi: "write:debug",
          },
          {
            title: "Rinomina utente",
            url: "correggiUtenti",
            permessi: "write:debug",
          },
          {
            title: "EAN to CODVS",
            url: "eanToCodvs",
            permessi: "read:debug",
          },
        ],
      },
      {
        title: "Componenti UI",
        url: "ui-components",
        permessi: "read:debug",
        submenu: [
          {
            title: "Skeleton",
            url: "ui-components-skeleton",
          },
        ],
      },
      {
        title: "Impostazioni",
        url: "impostazioni",
        permessi: "update:database",
      },
      {
        title: "Messaggio header",
        url: "header-message",
        permessi: "read:debug",
      },
      {
        title: "Variabili ambiente",
        url: "variabili-ambiente",
        permessi: "read:debug",
      },
      {
        title: "Regole automatismi logistica",
        url: "regole-automatismi-logistica",
        permessi: "read:debug",
      },
    ],
  },
  {
    title: "Rubrica",
    url: "anagraficheLogistica",
    permessi: "read:logistica",
    mobile: false,
  },
];
